import  {baseActions}  from "./base.actions";

export const cityActions = {
   
    gets,
    get,
    
};


function gets() {
    return baseActions.getall('city');
}

function get(id)
{
    return baseActions.get('city',id);
}
